const banner = '/assets/centropuerto/Home/Home-Banner-01.webp';
const email = '/assets/ivergrama/General/email-icon.svg';
const PopupIcon = '/assets/ivergrama/gallery/gallery5.jpg';
const BookingActive = '/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-BuyTicket.svg';
const CancelActive = '/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-CancelTicket.svg';
const CuponeraActive = '/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-Cuponera.svg';
const ConfirmCuponeraActive =
	'/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-Confirm-Cuponera.svg';

const OriginIcon = '/assets/centropuerto/Home/Origen Icon.png';
const DestinationIcon = '/assets/centropuerto/Home/Destino Icon.png';
const CalendarIcon = '/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-Calendar.svg';
// const SearchIcon = '/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-SearchIcon.svg';
const titleUnderline = '/assets/ivergrama/General/Ivergrama-Website-Titles.svg';

const sendBtn = '/assets/ivergrama/Home/Ivergrama-Website-Home-SendContact.svg';
const contactFormImg = '/assets/ivergrama/Home/Ivergrama-Website-Home-BannerSpecialServices.jpg';

const fb = '/assets/ivergrama/General/Ivergrama-Website-Footer-SocialMedia-Facebook.svg';
const fbHover = '/assets/ivergrama/General/Ivergrama-Website-Footer-SocialMedia-Facebook-hover.svg';
const twitter = '/assets/ivergrama/General/Ivergrama-Website-Footer-SocialMedia-Twitter.svg';
const twitterHover =
	'/assets/ivergrama/General/Ivergrama-Website-Footer-SocialMedia-Twitter-Hover.svg';

const LocationIcon = '/assets/ivergrama/general/LocationIcon.svg';
const PhoneIcon = '/assets/ivergrama/general/PhoneIcon.svg';
const HeaderLogo = '/assets/ivergrama/general/Header-BusesTepualLogo.svg';
const FooterLogo = '/assets/ivergrama/general/Footer-BusesTepualLogo.svg';
const checkboxIcon = '/assets/centropuerto/buy/Centropuerto-Check-Sprite.png';
const BottomFooterKuposLogo = '/assets/common/Footer-kuposLogo.svg';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/ivergrama/General/Ivergrama-Website-Home-WhereToFindMyPNR.svg';

const contactMail = '/assets/ivergrama/Contact/email-icon.svg';
const contactAddress = '/assets/ivergrama/Contact/location-icon.svg';

const servicesBanner = '/assets/ivergrama/Home/Banner-nuestros-servicios.png';
const companyBanner = '/assets/centropuerto/Empresa/Empresa-Banner.png';
const airportbanner = '/assets/centropuerto/Rutas/Rutas-Banner.png';

const aboutUsImage = '/assets/ivergrama/aboutUs/Ivergrama-Website-AboutUs-HistoryImage.jpg';
// banners
const destinationBanner = '/assets/ivergrama/destinations/destination-main.jpg';
const serviceBanner = '/assets/ivergrama/Services/Ivergrama-Website-Services-MainBanner.jpg';
const faqBanner = '/assets/ivergrama/Home/Preguntas-frecuentes-banner.png';
const contactUsBanner = '/assets/ivergrama/Contact/Ivergrama-Website-Contact-MainBanner.jpg';
const aboutUsBanner = '/assets/ivergrama/aboutUs/Ivergrama-Website-AboutUs-MainBanner.jpg';
const tncBanner = '/assets/ivergrama/tnc/Ivergrama-Website-TermsAndConditions-MainBanner.jpg';
const officeBanner = '/assets/ivergrama/offices/offices-banner.jpg';

const OfficePhoneIcon = '/assets/ivergrama/general/officePhone.svg';

const success = '/assets/centropuerto/success-tick.svg';
const failure = '/assets/centropuerto/fail-cross.svg';

const tick = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tick-Gray.svg';
const heartOn = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOn-Gray.svg';
const heartOff = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-HeartOff-Gray.svg';
const downArrow = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-DropDown-Gray.svg';
const registrationSuccess =
	'/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RightDocument-Gray.svg';
const userIcon = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Login-Gray.svg';
const trips = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-MyTrips-Gray.svg';
const cards = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-MyCards-Gray.svg';
const wallet = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const transaction = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ShareMoney-Gray.svg';
const otp = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RestorePassword-Gray.svg';

const paso_1 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const paso_2 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-RechargePoints-Gray.svg';
const paso_3 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-ID-Gray.svg';
const paso_4 = '/assets/ivergrama/Gray/MyAccount-IllustratedIcons-Tickets-Gray.svg';

//  pet seat
const petseatref =
	'/assets/ivergrama/pet/Ivergrama-ResultPage-SeatPick-PetsOnBoard_Pet Paw Icon (Amenite).svg';
const petseatModal = '/assets/ivergrama/pet/PopUp.png';
const petfilteroff = '/assets/ivergrama/pet/Ivergrama-ResultPage-PetsOnBoard-Button-Filter_off.svg';
const petfilteron = '/assets/ivergrama/pet/Ivergrama-ResultPage-PetsOnBoard-Button-Filter_On.svg';

const operatorPay = '/assets/ivergrama/iverpay.png';
const whiteDownArrow = '/assets/ivergrama/Home/Down-arrow.svg';
const tncDownArrow = 'assets/ivergrama/tnc/arrow-icon.svg';
const accordOpen = 'assets/centropuerto/Preguntas/Forward arrow blue.png';
const accordClose = 'assets/centropuerto/Preguntas/P.frecuentes-inactive.png';

const mailIconContact = 'assets/centropuerto/Contacto/Contacto-mail.svg';
const phoneIconContact = 'assets/centropuerto/Contacto/Contacto-phone.svg';
const contactBanner = '/assets/centropuerto/Contacto/Contacto-Banner-01.webp';
const faqsBanner = '/assets/centropuerto/Preguntas/Preguntas frecuentes-Banner-01.webp';
const TelephoneIconFooter = '/assets/centropuerto/Home/telephone-white.svg fill.png';
const EmailIconFooter = '/assets/centropuerto/Home/email-white.svg fill.png';
const arrowdown = '/assets/centropuerto/Home/email-white.svg fill.png';
const servicebanner = '/assets/centropuerto/Home/new-tariff.png';

const centropuertoIcons = [
	{
		icon: mailIconContact,
		name: 'mailIconContact',
	},
	{
		icon: faqsBanner,
		name: 'faqsBanner',
	},
	{
		icon: phoneIconContact,
		name: 'phoneIconContact',
	},
	{
		icon: contactBanner,
		name: 'contactBanner',
	},

	{ icon: banner, name: 'Banner' },
	{ icon: arrowdown, name: 'arrowdown' },

	{ icon: downArrow, name: 'downArrow' },
	{ icon: tncDownArrow, name: 'tncDownArrow' },
	{ icon: accordOpen, name: 'accordOpen' },
	{ icon: accordClose, name: 'accordClose' },

	{ icon: whiteDownArrow, name: 'whiteDownArrow' },

	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: PhoneIcon, name: 'phone' },
	{ icon: email, name: 'email' },
	{ icon: LocationIcon, name: 'location' },
	{ icon: HeaderLogo, name: 'headerLogo' },
	{ icon: FooterLogo, name: 'footerLogo' },
	{ icon: contactFormImg, name: 'contactFormImg' },
	{ icon: titleUnderline, name: 'titleUnderline' },

	{ icon: sendBtn, name: 'sendBtn' },
	{ icon: fb, name: 'fb' },
	{ icon: fbHover, name: 'fbHover' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: twitter, name: 'twitter' },
	{ icon: twitterHover, name: 'twitterHover' },

	{ icon: BookingActive, name: 'BA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: CuponeraActive, name: 'CUA' },
	{ icon: ConfirmCuponeraActive, name: 'CCA' },

	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: CalendarIcon, name: 'Calendar' },
	// { icon: SearchIcon, name: 'Search' },
	{ icon: PopupIcon, name: 'Popup' },
	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: BottomFooterKuposLogo, name: 'BottomFooterKuposLogo' },
	{ icon: animation, name: 'animation' },
	{ icon: pnr, name: 'pnr' },
	{ icon: OfficePhoneIcon, name: 'OfficePhoneIcon' },

	{ icon: contactMail, name: 'contactMail' },
	{ icon: contactAddress, name: 'contactAddress' },
	{ icon: destinationBanner, name: 'destinationBanner' },
	{ icon: faqBanner, name: 'faqBanner' },
	{ icon: serviceBanner, name: 'serviceBanner' },
	{ icon: contactUsBanner, name: 'contactUsBanner' },
	{ icon: aboutUsImage, name: 'aboutUsImage' },
	{ icon: aboutUsBanner, name: 'aboutUsBanner' },
	{ icon: tncBanner, name: 'tncBanner' },
	{ icon: officeBanner, name: 'officeBanner' },

	//  pet seat
	{ icon: petseatref, name: 'petseatref' },
	{ icon: petseatModal, name: 'petseatModal' },
	{ icon: petfilteron, name: 'petfilteron' },
	{ icon: petfilteroff, name: 'petfilteroff' },
	{ icon: operatorPay, name: 'operatorPay' },

	{ icon: servicesBanner, name: 'servicesBanner' },

	{ icon: TelephoneIconFooter, name: 'TelephoneIconFooter' },
	{ icon: EmailIconFooter, name: 'EmailIconFooter' },

	{ icon: servicebanner, name: 'servicebanner' },
	{ icon: companyBanner, name: 'companyBanner' },
	{ icon: airportbanner, name: 'airportbanner' },
];

export default centropuertoIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/centropuertoIcons.js